import React from 'react'
import {createRoot} from 'react-dom/client';

import BaseComponent, {AjaxParam} from '../../common/BaseComponent/BaseComponent'
import ComponentFooter from '../../components/ComponentFooter/ComponentFooter'
import ComponentHeaderPublic from '../../components/ComponentHeaderPublic/ComponentHeaderPublic'
import styles from './PageHosting.scss'
import HostingHeader from './HostingHeader/HostingHeader'
import ComponentHostingPlans from '../../components/ComponentHostingPlans/ComponentHostingPlans'
import HostingAdvantages from './HostingAdvantages/HostingAdvantages'
import HostingFrameworks from './HostingFrameworks/HostingFrameworks'
import HostingBlogPosts from './HostingBlogPosts/HostingBlogPosts'
import {ContextServicePriceProvider} from '../../context/ContextServicePriceProvider'
import {ContextCartProvider} from '../../context/ContextCartProvider'
import {ContextTaxonomyProvider} from '../../context/ContextTaxonomyProvider'
import {ContextServicesFeaturesTableProvider} from '../../context/ContextServicesFeaturesTable'

class PageHosting extends BaseComponent {
	constructor() {
		super(...arguments, 'PageHosting');
		SHVO.pageComponent = this;
	}

	addSSToCart = (priceId, breadCrumbMode) => {
		const ajaxParam = new AjaxParam()
		ajaxParam.isLoading = false
		this.ajaxCall('ActionAddSSToCart', {priceId, breadCrumbMode}, ajaxParam)
	}

	actionContinue = () => {
		const ajaxParam = new AjaxParam()
		ajaxParam.isLoading = false
		this.ajaxCall('ActionContinue', {}, ajaxParam)
	}

	render() {

		const header = this.props.data.componentData.header;
		return (
		  <>
			  <ComponentHeaderPublic data={header} isLazy={'1'}/>

			  <div className={styles.content}>
				  <HostingHeader/>
				  <ContextServicePriceProvider>
					  <ContextCartProvider>
						  <ContextTaxonomyProvider>
							  <div className={styles.hostingContainer}>
								  <ComponentHostingPlans
									addSSToCart={this.addSSToCart}
									actionContinue={this.actionContinue} springPromo={true}/>
							  </div>
						  </ContextTaxonomyProvider>
					  </ContextCartProvider>
				  </ContextServicePriceProvider>


				  <ContextServicePriceProvider contextName="contextServicePriceProviderAll">
					  <ContextServicesFeaturesTableProvider>
						  <HostingAdvantages/>
					  </ContextServicesFeaturesTableProvider>
				  </ContextServicePriceProvider>

				  <HostingFrameworks/>

				  {SHVO.pageLang !== 'en' ?
					<HostingBlogPosts/>
					: ''}

				  <ComponentFooter/>
			  </div>
		  </>
		)
	}
}

const container = document.getElementById(SHVO.pageAppId);
const root = createRoot(container);
root.render(<PageHosting data={SHVO.pageState}/>);